import React from 'react';
import {useSelector} from "react-redux";

import styles from './ServicePackageItem.module.scss';
import check from '../../../constants/images/check-icon-orange.svg';
import more from '../../../constants/images/info-fill.svg';

const ServicePackageItem = ({id, name, price, services, setIsModalMoreInfoPackageOpen, handleSelectPackage}) => {
    const {service_package} = useSelector(state => state.stepperInfo);

    return (
        <div
            onClick={() => handleSelectPackage(id, name, +price, services.toString().split(', '))}
            className={`${styles.servicePackage_wrapper} 
            ${(service_package.name === name) ? styles.selected : ''}`}
        >
            <div className={styles.servicePackage_wrapper_titleContainer}>
                <div className={styles.servicePackage_wrapper_titleContainer_packageName}>
                    <h2 className={styles.name}>{name}</h2>
                    <img
                        onClick={() => setIsModalMoreInfoPackageOpen(true)}
                        src={more}
                        alt="info more icon"
                    />
                </div>

                <p className={styles.price}>Від ₴{+price}</p>
            </div>

            <div className={styles.servicePackage_wrapper_services}>
                {services?.length > 0 && services.toString().split(', ').map((item, index) =>
                    <div className={styles.servicePackage_wrapper_services_item} key={index}>
                        <img src={check} alt="check icon"/>
                        <p>{item}</p>
                    </div>)}
            </div>
        </div>
    );
};

export default ServicePackageItem;
